import { Box, type SxProps, type Theme, useTheme } from '@mui/material';
import type { JSONContent } from '@tiptap/core';
import { RichTextReadOnly } from 'mui-tiptap';
import { tiptapContentExtensions, tiptapStyles } from '@/utils/server/tiptap';

export default function RichContent({
  content,
  noParagraphMargin = false,
}: {
  content: JSONContent;
  noParagraphMargin?: boolean;
}) {
  const theme = useTheme();
  const baseStyles = tiptapStyles(theme);

  const combinedStyles: SxProps<Theme> = noParagraphMargin
    ? ([
        baseStyles,
        {
          '& .MuiTiptap-RichTextContent-root, & .MuiTiptap-RichTextContent-readOnly': {
            '& .tiptap.ProseMirror': {
              '& p': {
                mb: 0,
              },
            },
          },
        },
      ] as SxProps<Theme>)
    : baseStyles;

  return (
    <Box sx={combinedStyles}>
      <RichTextReadOnly
        content={content}
        extensions={tiptapContentExtensions}
        immediatelyRender={false}
      />
    </Box>
  );
}
